import {
  createStore
} from 'vuex'
import createPersistedState from 'vuex-persistedstate';
import {
  showToast
} from 'vant'
import ls from '@/utils/localStore.js';
import {
  autologin
} from "@/api/index.js"
// import Cookies from "js-cookie";

export default createStore({
  state: {
    isLogin: false,
    token: null,
    userInfo: null,
    channelId: null,
  },
  getters: {},
  mutations: {
    // 设置渠道
    SET_CHANNEL_ID: (state, channelId) => {
      if (channelId) {
        state.channelId = channelId;
      }
    },
    // 设置token
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    // 设置用户信息
    SET_USER_INFO: (state, userInfo) => {
      state.userInfo = userInfo
    },
    // 设置用户昵称
    SET_NICK_NAME: (state, nickName) => {
      state.userInfo.nickName = nickName
      // ls.set('userinfo', state.userInfo)
    },
    // 设置用户手机
    SET_TELPHONE: (state, telphone) => {
      state.userInfo.telphone = telphone
      // ls.set('userinfo', state.userInfo)
    },
    // 设置用户姓名
    SET_REALNAME: (state, realName) => {
      state.userInfo.realName = realName
      // ls.set('userinfo', state.userInfo)
    },
    // 设置用户身份证
    SET_IDCARD: (state, idCard) => {
      state.userInfo.idCard = idCard
      // ls.set('userinfo', state.userInfo)
    },
    // 登录状态
    SET_IS_LOGIN: (state, isLogin) => {
      state.isLogin = isLogin;
    },
  },
  actions: {
    init({
      commit
    }) {
      //showDialog({ message: 'cookie：'+document.cookie })
      if (document.cookie) {
        console.log(1)
        //const cookies = document.cookie.replaceAll(" ", "");
        const cookies = document.cookie;
        console.log(cookies)
        autologin({
          cookie: cookies
        }).then(res => {
          if (res.data.code == 200) {
            const {
              token,
              user
            } = res.data.data
            console.log(token)
            console.log(user)

            //showDialog({ message: 'userinfo：'+ JSON.stringify(user) })
            commit("SET_IS_LOGIN", true)
            commit("SET_USER_INFO", user);
            commit("SET_TOKEN", "bearer " + token);
          } else {
            showToast(res.data.msg)
          }
        })
      } else {
        console.log(2)
        const userinfo = ls.get('userinfo');
        const token = ls.get('token');
        if (userinfo && token) {
          commit("SET_IS_LOGIN", true);
        } else {
          showToast('请先登录！')
        }
        commit("SET_USER_INFO", userinfo);
        commit("SET_TOKEN", token);
      }

    },
    logout({
      commit
    }) {
      commit("SET_IS_LOGIN", false);
      commit("SET_USER_INFO", null);
      commit("SET_TOKEN", null);

      ls.remove('userinfo');
      ls.remove('token');
    },
  },
  modules: {},
  plugins: [
    createPersistedState({
      storage: window.localStorage, // 或者使用 sessionStorage
      key: '28zhexfcvuex', // 存储的 key 名，默认为 'vuex'
      // paths: ['user', 'preferences'] // 如果你只想持久化部分状态，可以通过 paths 指定
    })
  ]
})
